import CityPageTemplate from "../city-template/CityPageTemplate";
import { laCrosseConfig } from "./data";

export default function LaCrossePage() {
  return <CityPageTemplate config={laCrosseConfig} />;
}